import React from "react";
import FormBuilder from "../../components/formBuilder/FormBuilder";

export default function AddNew() {
  return (
    <>
      <div className="content">
        <div className="page-header">
          <div className="page-title">
            <h4>Create New Form</h4>
            <h6>Set up customize form with custom field to get your sales.</h6>
          </div>
        </div>

        <div className="card">
          <div className="card-header">
            <h4>Add Form Details</h4>
          </div>
          <div className="card-body profile-body">
            <FormBuilder
              onSaved={(saved) => {
                console.log("Saved form:", saved);
                // e.g. navigate("/admin/forms")
              }}
            />
          </div>
        </div>
      </div>
    </>
  );
}
